export const headCells= [
                    {
                      id: "name",
                      numeric: true,
                      disablePadding: false,
                      label: "Name",
                    },
                    {
                      id: "phone_number",
                      numeric: true,
                      disablePadding: false,
                      label: "Phone number",
                    },
                    {
                      id: "status",
                      numeric: true,
                      disablePadding: false,
                      label: "Status",
                    },
                    {
                      id: "last_contacted",
                      numeric: true,
                      disablePadding: false,
                      label: "Last Contacted",
                    },
                    {
                      id: "last_contacted",
                      numeric: true,
                      disablePadding: false,
                      label: "Appointment Details",
                    },
                    {
                      id: "action",
                      numeric: true,
                      disablePadding: false,
                      label: "Action",
                    },
                  ];